import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../../../utils/request';
import { blobToDataURL } from '../../../utils/images';

class FirebaseImage extends React.Component {
  state = {
    status: 'loading',
  };

  componentWillMount() {
    get({
      url: this.props.path,
    }).then((data) => {
      blobToDataURL(data, (dataUrl) => {
        console.log('url', dataUrl);
        this.setState({
          src: dataUrl,
          status: 'found',
        });
      })
    }).catch((err) => {
      if (err.statusCode !== 404) {
        console.log('imagedownload', err, err.statusCode);
      }

      this.setState({
        status: 'notFound',
      });
    })
  }

  render() {
    const { notFound, height, width } = this.props;
    const { src, status } = this.state;

    if (status === 'notFound') {
      return notFound;
    }

    return (<img
      id="image"
      src={status === 'loading' ? '/images/loading.gif' : src}
      alt="img"
      style={{ height, width: width ? width : 'auto' }}
    />);
  }
}

FirebaseImage.propTypes = {
  path: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  notFound: PropTypes.object,
};

export default FirebaseImage;



// WEBPACK FOOTER //
// ./src/components/Common/FirebaseImage/index.js